<template>
  <div>
    <v-expansion-panels class="mb-2" id="expandableFilters">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span>
            <v-icon left small>mdi-filter-outline</v-icon>
            Filtres
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="ml-3">
            <v-col cols="6" sm="4" md="3">
              <partner-group-filter store="dataAvailability" />
            </v-col>
            <v-col cols="6" sm="4" md="6">
              <partner-view-filter store="dataAvailability" />
            </v-col>
            <v-col cols="6" sm="4" md="3">
              <threshold-filter />
            </v-col>
          </v-row>
          <v-row class="ml-3">
            <v-col cols="6" sm="4" md="3">
              <site-group-filter store="dataAvailability" />
            </v-col>
            <v-col cols="6" sm="4" md="6">
              <site-filter store="dataAvailability" />
            </v-col>
          </v-row>
          <v-row class="ml-3 mt-4">
            <v-col cols="12" class="text-right">
              <apply-filters
                :disabled="isLoading"
                :executeOnLoad="true"
                outlined
                color="secondary"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import ApplyFilters from "@/components/common/filters/ApplyFilters";
import PartnerGroupFilter from "@/components/common/filters/PartnerViewGroupFilter";
import PartnerViewFilter from "@/components/common/filters/PartnerViewFilter";
import SiteFilter from "@/components/common/filters/SiteFilter";
import SiteGroupFilter from "@/components/common/filters/SiteGroupFilter";
import ThresholdFilter from "./ThresholdFilter";

import useAxios from "@/hooks/useAxios";

export default {
  name: "DataAvailabilityFilters",
  components: {
    ApplyFilters,
    PartnerGroupFilter,
    PartnerViewFilter,
    SiteFilter,
    SiteGroupFilter,
    ThresholdFilter,
  },
  setup() {
    const { isLoading } = useAxios();

    return {
      isLoading,
    };
  },
};
</script>

<style>
.v-date-picker-title__date > div {
  font-size: 22px;
}
</style>
